module.exports = __webpack_public_path__ + "static/media/404.43cba565.png";